import React from "react";
import { Box } from "@mui/material";
import { useFormikContext, getIn } from "formik";
// component
import { InputField } from "./view/InputField";
import { getCurrency } from "helper/numberFormat";
// direct import
import "./style.scss";
import { fontConfig } from "theme/fontConfig";

const CommonInputField = ({
  name,
  title,
  placeholder,
  mandatory = false,
  maxLength = 30,
  checkValidation = true,
  style,
  titleStyle = {
    fontFamily: fontConfig.FormManageCommonInputFieldTitleStyleFont.family,
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#4F4F4F",
  },
  type,
  taxTypePath,
  onChange,
  max,
  ...rest
}) => {
  const currency = getCurrency();
  const formik = useFormikContext();
  const { values, setFieldValue, errors, touched } = formik;

  const getError = getIn(errors, name);
  const getTouch = getIn(touched, name);
  const fieldValue = getIn(values, name) || "";
  const selectedTaxType = taxTypePath ? getIn(values, taxTypePath) : null;

  const handleInputChange = (e) => {
    const value = e.target?.value;
    onChange && onChange(e);
    if (!value?.trim()?.length) {
      setFieldValue(name, "");
      return;
    }
    if (max !== undefined && parseFloat(value) > max) return;
    setFieldValue(name, value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }

    if (e.key === " " && fieldValue === "") {
      e.preventDefault();
    }

    if (type === "number") {
      const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      if (!allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  return (
    <Box className="common_input">
      <InputField
        title={title}
        name={name}
        formik={formik}
        checkValidation={checkValidation}
        mandatory={mandatory}
        placeholder={placeholder}
        titleStyle={titleStyle}
        maxLength={maxLength}
        style={style}
        value={fieldValue}
        handleChange={handleInputChange}
        onKeyPress={handleKeyPress}
        type={type}
        max={max}
        error={getError}
        getTouch={getTouch}
        notIcon={true}
        {...rest}
      />

      {taxTypePath && (
        <Box
          className={`${
            checkValidation && getTouch && getError ? "is-tax_type" : "tax_type"
          }`}
        >
          <span
            onClick={() => setFieldValue(taxTypePath, "$")}
            className={
              selectedTaxType === "$" ? "text-primary tax_type_selected" : ""
            }
          >
            {currency}
          </span>
          <span>|</span>
          <span
            onClick={() => setFieldValue(taxTypePath, "%")}
            className={
              selectedTaxType === "%" ? "text-primary tax_type_selected" : ""
            }
          >
            %
          </span>
        </Box>
      )}
    </Box>
  );
};

export default CommonInputField;
